/**
 * Application-level configuration. Values that affect data access live here so
 * the whole app reads from a single source of truth.
 */

/**
 * Base URL of the backend REST API. Computed at build/dev time by
 * vite.config.ts (VITE_DEV_MODE + VITE_LOCAL_API_URL / VITE_PROD_API_URL)
 * and inlined via `define`, so a stray VITE_DEV_MODE=true can never leak
 * into a production build — `npm run build` always resolves to the prod URL
 * regardless of what's in .env.
 */
export const API_BASE_URL: string = import.meta.env.VITE_API_URL ?? "";

/**
 * When true, every service function resolves against mock data in
 * src/mocks with identical signatures. Only src/services/auth.ts currently
 * branches on this — every other module service is still mock-only
 * regardless, until its own backend module exists.
 */
export const USE_MOCK_API: boolean = API_BASE_URL === "";

/** Brand shown across auth screens. */
export const ORGANIZATION_NAME = "M.K. FINANCIAL SERVICES";
export const ORGANIZATION_TAGLINE = "Finance Management System";